import type { Dayjs } from 'dayjs';
import { useCallback, useState } from 'react';

import type { AvailabilityFormValues } from '../_components/AvailabilityForm/availabilityForm.types';
import type { TimeslotEvent } from '../_components/CalendarEvent/CalendarEvent';
import { buildTemporaryEvents, sameTemporaryEvents } from '../utils/events';
import type { IsDayClosed } from '../utils/events';

export const useTimeslotDraftPreview = () => {
  const [temporaryEvents, setTemporaryEvents] = useState<TimeslotEvent[]>([]);

  const preview = useCallback(
    (
      values: AvailabilityFormValues | null,
      excludeDate?: Dayjs,
      isDayClosed?: IsDayClosed
    ) => {
      const next = values
        ? buildTemporaryEvents(values, excludeDate, isDayClosed)
        : [];

      setTemporaryEvents((prev) =>
        sameTemporaryEvents(prev, next) ? prev : next
      );
    },
    []
  );

  const clear = useCallback(() => setTemporaryEvents([]), []);

  return { temporaryEvents, preview, clear };
};
